import { Injectable } from '@angular/core';

import {
	AirBnbUnSelected,
	AirBnbSelected,
	IntegrationDomain,
	AirBnbTypes,
	AirBnbNotSupported,
	AirBnbSelectedState,
	AirBnb,
	HospitableDirectNotSupported,
	HospitableDirectTypes,
	HospitableDirectUnSelected,
	HospitableDirect,
	HospitableDirectSelected,
	HospitableDirectSelectedState,
	VrboTypes,
	VrboUnSelected,
	VrboNotSupported,
	VrboSelected,
	VrboSelectedState,
	Vrbo,
} from 'models';

@Injectable({
	providedIn: 'root',
})
export class IntegrationExclusionService {
	public getAirBnbDisplayProperties(integration: IntegrationDomain): AirBnbTypes {
		return integration.integrationType.airBnbIsSupported ? this.withSupported(integration) : new AirBnbNotSupported();
	}

	public getDirectDisplayProperties(integration: IntegrationDomain): HospitableDirectTypes {
		return integration.integrationType.directIsSupported ? this.withSupportedHospitableDirect(integration) : new HospitableDirectNotSupported();
	}

	public getVrboDisplayProperties(integration: IntegrationDomain): VrboTypes {
		return integration.integrationType.vrboIsSupported ? this.withVrboSupported(integration) : new VrboNotSupported();
	}

	public getModel(isSelected: boolean): AirBnb {
		const airBnbModel = new AirBnb();
		airBnbModel.isExcluded = isSelected;
		return airBnbModel;
	}

	public getModelDirect(isSelected: boolean): HospitableDirect {
		const directModel = new HospitableDirect();
		directModel.isExcluded = isSelected;
		return directModel;
	}

	public getModelVrbo(isSelected: boolean): Vrbo {
		const directModel = new Vrbo();
		directModel.isExcluded = isSelected;
		return directModel;
	}

	private withSupportedHospitableDirect(integration: IntegrationDomain): HospitableDirectTypes {
		return integration.exclusion ? this.DirectfindState(integration) : new HospitableDirectUnSelected();
	}

	private withSupported(integration: IntegrationDomain): AirBnbTypes {
		return integration.exclusion ? this.findState(integration) : new AirBnbUnSelected();
	}

	private withVrboSupported(integration: IntegrationDomain): VrboTypes {
		return integration.exclusion ? this.findVrboState(integration) : new VrboUnSelected();
	}

	private findState(integration: IntegrationDomain): AirBnbTypes {
		return integration.exclusion.airBnb ? this.getState(integration.exclusion.airBnb.isExcluded) : new AirBnbUnSelected();
	}

	private DirectfindState(integration: IntegrationDomain): HospitableDirectTypes {
		return integration.exclusion.hospitableDirect ? this.DirectgetState(integration.exclusion.hospitableDirect.isExcluded) : new HospitableDirectUnSelected();
	}

	private findVrboState(integration: IntegrationDomain): VrboTypes {
		return integration.exclusion.vrbo ? this.getVrboState(integration.exclusion.vrbo.isExcluded) : new VrboUnSelected();
	}

	private DirectgetState(isSelected: boolean): HospitableDirectSelectedState {
		const state = isSelected ? new HospitableDirectSelected() : new HospitableDirectUnSelected();
		return state;
	}

	private getState(isSelected: boolean): AirBnbSelectedState {
		const state = isSelected ? new AirBnbSelected() : new AirBnbUnSelected();
		return state;
	}

	private getVrboState(isSelected: boolean): VrboSelectedState {
		const state = isSelected ? new VrboSelected() : new VrboUnSelected();
		return state;
	}
}
